import axios from 'axios'
import { generateResponse, generateErrorResponse } from './common'

const API_END_POINT = process.env.API_END_POINT
const MANIPULATOR = API_END_POINT + '/manipulator'
const MANIPULATOR_COMPANIES = API_END_POINT + '/manipulator/companies'
const MANIPULATOR_COMPANY_VACANCIES = API_END_POINT + '/company/vacancies'
const RECRUITED = MANIPULATOR + '/company/recruited'
const RESEND_ACTIVE_ACCOUNT_EMAIL = API_END_POINT + '/auth/resentactiveaccountemail'

export default {
  API_END_POINT: API_END_POINT,
  reSentActiveAccountEmail (token) {
    return axios({
      url: RESEND_ACTIVE_ACCOUNT_EMAIL,
      method: 'post',
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  starOrArchiveRecruitedResumes (token, id, type, status) {
    return axios({
      url: RECRUITED,
      method: 'put',
      data: {
        id: id,
        type: type,
        status: status
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getRecruitedResumeById (token, id) {
    return axios({
      url: RECRUITED + '/' + id,
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getRecruitedResumes (token, params) {
    return axios({
      url: RECRUITED,
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  switchCompanyVacancyStatus (token, data, status) {
    let options = {
      url: MANIPULATOR_COMPANY_VACANCIES,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }
    if (status === 'deleted') {
      options.url = MANIPULATOR_COMPANY_VACANCIES
      options.method = 'delete'
      options.data = {
        vacancies: data.vacancies
      }
      return axios(options)
        .then(generateResponse, generateErrorResponse)
    } else {
      let changeStatus
      if (status) {
        changeStatus = 'published'
      } else {
        changeStatus = 'unpublished'
      }
      options.data = {
        vacancies: data.vacancies,
        changeStatus: changeStatus
      }
      return axios(options)
        .then(generateResponse, generateErrorResponse)
    }
  },
  getCompanyVacancies (token, params) {
    return axios({
      url: MANIPULATOR_COMPANY_VACANCIES,
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getCompanyByAlias (token, alias) {
    return axios({
      url: MANIPULATOR_COMPANIES,
      method: 'get',
      params: {
        alias: alias
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getFirstCompany (token) {
    return axios({
      url: MANIPULATOR_COMPANIES,
      method: 'get',
      params: {
        first: true
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  deleteById (token, id, data) {
    return axios({
      url: MANIPULATOR + '/' + id,
      method: 'delete',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  updateById (token, id, data) {
    return axios({
      url: MANIPULATOR + '/' + id,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  add (token, data) {
    return axios({
      url: MANIPULATOR,
      method: 'post',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getById () {

  },
  get (params = { page: 1 }) {
    return axios({
      url: MANIPULATOR,
      method: 'get',
      params: params
    }).then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/manipulators.js